import { IsNotEmpty, IsString } from '@viterbit/web-app/shared/utils/ClassValidators'


export default class FormDeleteValidator {
    @IsString()
    @IsNotEmpty()
    name: string
}
